module.exports = __webpack_public_path__ + "img/sq4d_feature_02.0d256eac.jpg";